import firebase from '../../firebase';

export default async function createRide(params) {
    const ride = await firebase.functions().httpsCallable('rides-create')(params);
    if (ride && ride.data) {
        return ride.data;
    }
    return null;
}
